document.addEventListener('DOMContentLoaded', function() {
  const badge = document.querySelector('.dietro-quinte-badge');
  const videoContainer = document.querySelector('.video-container');
  
  if (badge && videoContainer) {
    badge.style.cursor = 'pointer';
    
    badge.addEventListener('click', function() {
      videoContainer.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    });
  }
});